import {footerActionTypes} from "./actionTypes";

export const setFooter = payload => ({
    type: footerActionTypes.SET_FOOTER,
    payload
});
